import React from "react";

export default function Spinner() {
  return (
    <div className="spinner-border text-success text-center m-auto" role="status">
      <span className="sr-only">Loading...</span>
    </div>
  );
}
